import { Component, OnInit, OnDestroy } from '@angular/core';
import { EventOptionEnty } from '../shared/models/EventOptionEntity';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Events } from '../shared/models/Events';
import { EventparticipEntity } from '../shared/models/EventparticipEntity';
import { TranslateDocument } from '../shared/models/TranslateDocument';
import { TranslateRelLabelVO } from '../shared/models/TranslateRelLabelVO';
import { UserAppVO } from '../shared/models/UserAppVO';
import { CategoryLan } from '../shared/models/CategoryLan';


import { first } from 'rxjs/operators';


import { AuthenticationService } from '../_services';

@Component({
  selector: 'app-tovpil-electov',
  templateUrl: './tovpil-electov.component.html',
  styleUrls: ['./tovpil-electov.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class TovpilElectovComponent implements OnInit, OnDestroy {
  listOptionEvent: EventOptionEnty[];
  listOptionEventTmp: EventOptionEnty[];
  selectedOptions: string[];
  mapSelectted = new Map();
  evt?: Events;
  evenPart?: EventparticipEntity;
  userEvent?: UserAppVO;
  translateDoc?: TranslateDocument;
  lstTranslateDoc?: TranslateDocument[];
  lstRespTranslate: TranslateRelLabelVO[];
  mapFunction = new Map();
  mapLevels = new Map();
  welcomeId?: string;
  password?: string;
  language?: string;
  region?: string;
  existsErros: boolean;
  selecNum?: number = 0;

  event_group_name_?: string;
  eligible_guide_?: string;
  zonal_coordination_?: string;
  national_coordination_?: string;
  local_coordination_?: string;
  nationality_?: string;
  country_of_residence?: string;
  any_zone_team_experience_?: string;
  role_?: string;
  level_?: string;
  total_guides_to_choose_?: string;
  choosen_?: string;
  search_?: string;
  back_?: string;
  accept_?: string;
  yes_?: string;
  no_?: string;
  confirm_?: string;
  wish_to_continue_?: string;
  select_?: string;
  hiddenFields?: boolean = true;


  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService

  ) {


  }
  ngOnDestroy(): void {
  }
  ngOnInit(): void {
    this.selectedOptions = [];
    this.hiddenFields = true;
    this.route.queryParams
      .subscribe(
        params => {
          this.welcomeId = params.welcomeID.substr(10, params.welcomeID.length);
          this.password = params.welcomeID.substr(0, 10);
          this.language = params.group.substr(0, 2);
          this.region = params.group.substr(3, 4);
        });

    this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');

  }

  getOptionsLists() {
    this.apiService.getlistOptionsByEventId(
      {
        'eventId': this.evt.eventId
      }
    ).then(
      opts => {

        this.listOptionEvent = opts;
        this.listOptionEvent.forEach((element) => {
          element.functionId = this.mapFunction.get(element.functionId);
          element.funcLevel = this.mapLevels.get(element.funcLevel);
          this.mapSelectted.set(element.id.sequen, element);
        });
        this.listOptionEventTmp = opts;
      }
    );
  }
  getEventparticip() {
    this.apiService.getEventparticip({
      'eventId': this.evt.eventId,
      'password': this.password
    }).then(
      eventPar => {
        this.evenPart = eventPar;

        this.getOptionsLists();
      });
  }
  updateLstVotes() {
    this.apiService.updateLstVotes(
      {
        'username': this.welcomeId,
        'password': this.password,
        'language': this.language,
        'lstSeqFor': this.selectedOptions
      }
    ).then(
      usrApp => {

        this.userEvent = usrApp;

        this.sendTranslateMessage('event_msg_success_');
      }
    );
  }


  sendTranslateMessage(fieldId?: string) {
    this.apiService.getTranslateByLanguageField(
      {
        'key': {
          'fieldId': fieldId,
          'language': this.language
        }
      }
    ).then(
      trDoc => {

        this.translateDoc = trDoc;
        if (this.translateDoc != null && this.translateDoc.descrip != null) {
          this.addSingle('error', this.translateDoc.descrip, ' ');
          this.redirecConfirm(this.translateDoc.descrip);
        } else {
          this.addSingle('error', fieldId, ' ');
        }
      }
    );
    return fieldId;
  }
  addSingle(severity?: string, summ?: string, detail?: string) {
    this.messageService.add({ severity: severity, summary: summ, detail: detail });
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstCat: CategoryLan[];
    this.apiService.listByLanguageMultFields(
      {
        'language': this.language,
        'region': this.region,
        'lstLabels': ['eligible_guide_', 'zonal_coordination_', 'national_coordination_', 'local_coordination_', 'nationality_', 'country_of_residence', 'any_zone_team_experience_', 'role_', 'level_', 'total_guides_to_choose_', 'choosen_', 'search_', 'back_', 'accept_', 'yes_', 'no_', 'wish_to_continue_', 'confirm_', 'select_', 'event_group_name_']
      }
    ).then(
      trDocs => {
        this.lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.eligible_guide_ = map.get('eligible_guide_');
        this.zonal_coordination_ = map.get('zonal_coordination_');
        this.national_coordination_ = map.get('national_coordination_');
        this.local_coordination_ = map.get('local_coordination_');
        this.nationality_ = map.get('nationality_');
        this.country_of_residence = map.get('country_of_residence');
        this.any_zone_team_experience_ = map.get('any_zone_team_experience_');
        this.role_ = map.get('role_');
        this.level_ = map.get('level_');
        this.total_guides_to_choose_ = map.get('total_guides_to_choose_');
        this.event_group_name_ = map.get('event_group_name_');
        this.choosen_ = map.get('choosen_');
        this.search_ = map.get('search_');
        this.back_ = map.get('back_');
        this.accept_ = map.get('accept_');
        this.yes_ = map.get('yes_');
        this.no_ = map.get('no_');
        this.confirm_ = map.get('confirm_');
        this.wish_to_continue_ = map.get('wish_to_continue_');
        this.select_ = map.get('select_');
        this.apiService.getCategoryLang(
          {
            'language': this.language,
            'fieldId': 'Function'
          }
        ).then(
          categs => {
            lstCat = categs;
            lstCat.forEach((element) => {
              if (element.descripTo != null) {
                this.mapFunction.set(element.fieldVal, element.descripTo);
              } else {
                this.mapFunction.set(element.fieldVal, element.descrip);
              }
            });
            //map levels
            this.apiService.getCategoryLang(
              {
                'language': this.language,
                'fieldId': 'level'
              }
            ).then(
              categs => {
                lstCat = categs;
                lstCat.forEach((element) => {
                  if (element.descripTo != null) {
                    this.mapLevels.set(element.fieldVal, element.descripTo);
                  } else {
                    this.mapLevels.set(element.fieldVal, element.descrip);
                  }
                });
                this.getEventparticip();

                //end map levels

              });

          });


      });
  }

  checkValue(id, event: any) {

    if (this.selectedOptions.length == parseInt(this.evt.selecNum)) {
      this.hiddenFields = false;
      this.listOptionEvent = [];
      for (let ct = 0; ct < 5; ct++) {
        this.listOptionEvent[ct] = this.mapSelectted.get(event[ct]);
      }
    }
  }
  goBack() {
    this.confirmationService.confirm({
      message: this.wish_to_continue_ + '?',
      header: this.confirm_ + ' ' + this.back_,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.yes_,
      rejectLabel: this.no_,
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.hiddenFields = true;
        this.listOptionEvent = [];
        this.listOptionEvent = this.listOptionEventTmp;
        this.selectedOptions = [];
      },
      reject: (type) => {
        switch (type) {

          default:

            break;
        }
      }
    });

  }
  goAccept() {


    this.confirmationService.confirm({
      message: this.wish_to_continue_ + '?',
      header: this.confirm_ + ' ' + this.accept_,
      acceptLabel: this.yes_,
      rejectLabel: this.no_,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',

      accept: () => {

        this.apiService.getUserEvent(
          {
            'username': this.welcomeId,
            'password': this.password,
            'language': this.language
          }
        ).then(
          usrApp => {

            this.userEvent = usrApp;
            if (this.userEvent == null || this.userEvent.eventId == null) {
              this.sendTranslateMessage('event_msg_invalid_not_assig_');
            } else if (this.userEvent.message != null && this.userEvent.message != '') {
              this.sendTranslateMessage(this.userEvent.message);
            } else {

              this.updateLstVotes();
              this.redirecConfirm('');
            }
          }
        );




      },
      reject: (type) => {
        switch (type) {

          default:

            break;
        }
      }
    });



  }
  checDisaled() {
    return this.hiddenFields;
  }
  redirecConfirm(msg: string) {
    this.router.navigate(['electov/chooseConfirm'], { queryParams: { welcomeId: this.password + this.welcomeId, group: this.language + "_" + this.region, message: msg } });
  }

  displayList() {
    this.apiService.getUserEvent({
      'username': this.welcomeId,
      'password': this.password,
      'language': this.language
    }).then(
      usrApp => {
        this.userEvent = usrApp;
        if (this.userEvent == null || this.userEvent.eventId == null) {
          this.sendTranslateMessage('event_msg_invalid_not_assig_');
          
        } else if (this.userEvent.message != null && this.userEvent.message != '') {
          this.sendTranslateMessage(this.userEvent.message);
          this.redirecConfirm(this.userEvent.message);
        } else {

          this.apiService.getEventByShortName(
            {
              'shortName': this.welcomeId
            }
          ).then(
            event => {
              this.evt = event;
              this.getTranslatedLabels();
            });

        }
      }
    );
  }

  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {

          if (data.code == 'R-0200') {
            this.displayList();

          } else {


          }
        },
        error => {

        });

  }

}
